import BackupDeviceList from "../backup/backup.device.list";

const DbDeviceList = () => <BackupDeviceList backupKind="db" />;

export default DbDeviceList;
